import React, { Component } from 'react';
import './index.less';
import { getUrlValue } from '../../../../utils/common';
import {
  getHomechargePageUrlByOrderNo,
  getHomeChargeAfterSaleUrlByOrderNo
} from '../../../../api/filling-pile';
import ErrorImg from '@assets/pile/empty.png';

interface State {
  isError: boolean;
  errorMsg: string;
}
interface Props {
  history: {
    push: Function;
    replace: Function;
  };
  location: {
    state: {
      restore: object;
      ssid: string;
    };
  };
}

class Home extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      isError: false,
      errorMsg: ''
    };
  }

  // 外部单号转换
  getUrlValueFromPage = (
    externalOrderNo: string | null,
    createSource: string | null
  ) => {
    if (externalOrderNo && createSource) {
      getHomechargePageUrlByOrderNo({ externalOrderNo, createSource})
        .then(res => {
          console.log(res);
          window.location.href = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  // 售后外部单号转换
  getAfterSaleInfo = (
    externalOrderNo: string | null,
    createSource: string | null
  ) => {
    if (externalOrderNo && createSource) {
      getHomeChargeAfterSaleUrlByOrderNo({
        purchaseOrderNo: externalOrderNo,
        createSource
      })
        .then(res => {
          if (res.data) {
            const { orderNo } = res.data;
            orderNo && this.clickSetting(`/after-sales-service`, orderNo);
          } else {
            this.setState({
              isError: true,
              errorMsg: '售后工单正在创建中，稍后请重新进入'
            });
          }
        })
        .catch(err => {
          this.setState({
            isError: true,
            errorMsg: '售后工单正在创建中，稍后请重新进入'
          });
        });
    }
  };

  componentDidMount() {
    document.title = '家充服务';

    // 判断跳转页面
    const serviceUrl = getUrlValue('serviceList');
    const externalOrderNo = getUrlValue('externalOrderNo');
    const createSource = getUrlValue('createSource')
    const orderNo = getUrlValue('orderNo');
    const installation = getUrlValue('installation');
    const afterSales = getUrlValue('after-sales');
    const applyPrevious = getUrlValue('apply-previous');
    console.log('外部传参-externalOrderNo', externalOrderNo);
    if (installation) {
      this.getUrlValueFromPage(externalOrderNo, createSource);
    }
    if (serviceUrl) {
      this.clickSetting('/pile-service-list', orderNo);
    }

    const status: any = getUrlValue('status');
    if (installation && status === '1') {
      this.clickSetting(`/pile-installation`, orderNo);
    }
    if (installation && status === '0') {
      this.clickSetting(`/apply-to-install`, orderNo);
    }
    if (applyPrevious) {
      this.clickSetting('apply-previous', orderNo);
    }
    const serviceStatus = getUrlValue('service-status');
    if(serviceStatus){
      this.clickSetting(`/service-status`, orderNo)
    }
    const serviceProgress = getUrlValue('service-progress');
    if(serviceProgress){
      this.clickSetting(`/service-progress`, orderNo);
    }

    if (afterSales) {
      if (externalOrderNo) {
        this.getAfterSaleInfo(externalOrderNo, createSource);
        return
      }

      if (orderNo) {
        this.clickSetting(`/after-sales-service`, orderNo);
      }
      if (!orderNo) {
        this.clickSetting(`/after-sales`);
      }
    }

    const afterSalesPrevious = getUrlValue('after-sales-previous')
    if(afterSalesPrevious){
      this.clickSetting(`/after-sales-previous`, orderNo)
    }
    const serviceHelp = getUrlValue('service-help');
    if(serviceHelp){
      this.clickSetting('/service-help', orderNo);
    }
  }

  clickSetting = (page, orderNo?) => {
    this.props.history.replace({
      pathname: page,
      state: {},
      search: '?orderNo=' + (orderNo ? orderNo : '')
    });
  };

  render() {
    const { isError, errorMsg } = this.state;
    return (
      <div className='pile-apply-home-page'>
        {
          isError && (
            <div className='error-placeholder'>
              <img src={ErrorImg} alt='' className='error-img' />
              { errorMsg && <p className='error-msg'>{errorMsg}</p> }
            </div>
          )
        }
      </div>
    );
  }
}

export default Home;
